export default __webpack_public_path__ + "static/appstore-d33407274b770771aa1ffcaa602b1443.svg";